export default __webpack_public_path__ + "static/media/1947.20212678.png";